import { Badge } from '@chakra-ui/react';
import PropTypes from 'prop-types';

const STATUS_META = {
  not_paid: { label: 'Not Paid', colorScheme: 'gray' },
  partially_paid: { label: 'Partially Paid', colorScheme: 'orange' },
  fully_paid: { label: 'Fully Paid', colorScheme: 'green' },
};

const PaymentStatusBadge = ({ status }) => {
  const meta = STATUS_META[status] || STATUS_META.not_paid;
  return <Badge colorScheme={meta.colorScheme}>{meta.label}</Badge>;
};

PaymentStatusBadge.propTypes = {
  status: PropTypes.string,
};

export default PaymentStatusBadge;
